import React from 'react';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@/components/ui/accordion';
import { faqData } from '@/data/products';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { HelpCircle } from 'lucide-react';

export const FAQAccordion = () => {
    const { ref, isVisible } = useScrollAnimation();

    return (
        <section id="faq" className="py-16 md:py-24 bg-secondary/30">
            <div ref={ref} className="section-container">
                {/* Section Header */}
                <div
                    className={`text-center mb-10 ${
                        isVisible ? 'animate-fade-in-up' : 'opacity-0'
                    }`}
                >
                    <div className="inline-flex items-center gap-2 text-primary mb-3">
                        <HelpCircle className="h-5 w-5" />
                        <span className="text-sm font-semibold uppercase tracking-wide">
                            Häufige Fragen
                        </span>
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
                        FAQ – Ihre Fragen beantwortet
                    </h2>
                    <p className="text-muted-foreground max-w-2xl mx-auto">
                        Hier finden Sie Antworten auf die häufigsten Fragen rund um
                        Detox Tees.
                    </p>
                </div>

                {/* FAQ Accordion */}
                <div
                    className={`max-w-3xl mx-auto ${
                        isVisible ? 'animate-fade-in-up' : 'opacity-0'
                    }`}
                    style={{ animationDelay: '0.2s' }}
                >
                    <div className="bg-card rounded-2xl shadow-card border border-border overflow-hidden">
                        <Accordion type="single" collapsible className="w-full">
                            {faqData.map((faq, index) => (
                                <AccordionItem
                                    key={faq.id}
                                    value={faq.id}
                                    className="border-b border-border last:border-b-0"
                                >
                                    <AccordionTrigger className="px-6 py-5 text-left hover:no-underline hover:bg-muted/30 transition-colors group">
                                        <span className="font-semibold text-foreground group-hover:text-primary transition-colors pr-4">
                                            {faq.question}
                                        </span>
                                    </AccordionTrigger>
                                    <AccordionContent className="px-6 pb-5">
                                        <p className="text-muted-foreground leading-relaxed">
                                            {faq.answer}
                                        </p>
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>

                {/* Additional Info */}
                <p
                    className={`text-xs text-muted-foreground text-center mt-6 max-w-2xl mx-auto ${
                        isVisible ? 'animate-fade-in' : 'opacity-0'
                    }`}
                    style={{ animationDelay: '0.4s' }}
                >
                    Hinweis: Die hier bereitgestellten Informationen dienen
                    ausschließlich zu Informationszwecken und ersetzen keine
                    professionelle Beratung.
                </p>
            </div>
        </section>
    );
};
